import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    rankValue: '#{rank}',
    ofRankValue: ' of {totalRanks}',
    rank: 'Rank',
    delegationAPY: 'Delegation APY',
    commission: 'Commission',
  },
};
